import React from 'react'
import { LineChart } from '@mui/x-charts/LineChart'
import './Line.css'
const Line = ({ data, groupBy, xLabel, yLabel, title, height = 200, width = 400 }) => {

  // Definir períodos fijos según groupBy
  const periodSets = {
    month: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    quarter: ["Q1", "Q2", "Q3", "Q4"],
    cuatrimester: ["C1", "C2", "C3"],
    semester: ["S1", "S2"],
    year: [...new Set(data.map(d => d.year))], // años directos
    day: [...new Set(data.map(d => d.period))], // aquí depende de cómo venga
  };

  const periods = periodSets[groupBy] || [...new Set(data.map(d => d.period))];

  // Agrupar por año
  const groupedByYear = data.reduce((acc, item) => {
    if (!acc[item.year]) acc[item.year] = {};
    acc[item.year][item.period] = item.y;
    return acc;
  }, {});

  const years = Object.keys(groupedByYear);

  const colors = ["#15B79E", "#F2994A", "#0E5F79", "#9B51E0"];

  return (
    <div className="line-chart-container" style={{ height: '50%', width: '40%' }}>
      {title && <h3 className="chart-title">{title}</h3>}
      <div className="chart-wrapper">
        {(data && data.length > 0) ? (
          <LineChart
            xAxis={[{
              scaleType: 'point',
              data: periods,
              label: xLabel || '',
            }]}
            yAxis={[{
              min: 0,
              max: Math.max(...data.map(item => item.y || 0)),
              tickNumber: 6,
            }]}
            series={years.map((year, idx) => ({
              label: year,
              data: periods.map(p => groupedByYear[year][p] || 0),
              color: colors[idx % colors.length],
            }))}
            grid={{ vertical: true, horizontal: true }}
            height={height}
            width={width}
          />
        ) : (
          <div className="no-data-message">No data available</div>
        )}
      </div>
    </div>
  );
};

export default Line;
